// extracted by mini-css-extract-plugin
export var cell = "_4n-4";
export var headerCell = "_4n-2";
export var rowHeader = "_4n-3";
export var table = "_4n-1";
export var tableContainer = "_4n-0";